export default {
    payment_failed_please_contact_admin: 'Il tuo pagamento non può essere elaborato. Si prega di contattare l\'assistenza.',
    login: 'Accedi',
    forgot_password: "Hai dimenticato la tua password?",
    english: "English",
    german: "Deutsch",
    french: "Français",
    italian: "Italiano",
    dutch: "Nederlands",
    spanish: "Español",
    portuguese: "Português",
    english_short: "EN",
    german_short: "DE",
    french_short: "FR",
    italian_short: "IT",
    dutch_short: "NL",
    spanish_short: "ES",
    portuguese_short: "PT",
    no_more_photos_for_moderation: "Non ci sono altre immagini da moderare. Torna un po' più tardi. Grazie per il tuo aiuto 😘",
    timezone: 'Fuso orario',
    timezone_type_automatic: 'Il tuo fuso orario sarà rilevato automaticamente',
    timezone_type_manually: 'Il fuso orario scelto verrà bloccato',
    invalid_token_message: 'Per motivi di sicurezza, il tuo token di accesso è scaduto.\n' +
        'Richiedi un nuovo token per continuare.',
    try_again:'Riprova',
    add_links_to_profiles_events_clubs:'Aggiungi link a profili, eventi e club',
    you_can_add_only_twenty_links: 'Puoi aggiungere solo 20 link',
    enter_your_social_network_handle: 'Inserisci il tuo handle {social_network}',
    follow: 'Seguire',
    message: 'Message',
    message_copied: 'Copiato con successo',
    copied_from_clipboard: 'Copied from clipboard',
    reply: "rispondere",
    copy: "copiare",
    delete_for_all: "elimina per tutti",
    now: "ADESSO!",
    meet_now:"Incontra ADESSO!",
    activate_meet_now: "Attiva \"ADESSO!\" e mostra che sei pronto/a a incontrarti.",
    activate_now:"Attiva ADESSO!",
    deactivate_now:"Disattiva ADESSO!",
    meet_now_mini_text:"„ADESSO!“ rimane attivo per 30 minuti.",
    finished:"Finito?",
    over_now:"...finito ADESSO!",
    headline_or_nickname:"Titolo o Soprannome",
    meet_now_upgrade_to_pro:"„ADESSO!“ è stato attivato {0} volte oggi. Passa a PRO per riattivare „ADESSO!“ senza limiti.",
    activate_meet_now_n_times:"Attiva \"ADESSO!\" fino a {0} volte al giorno. I membri PRO possono attivare senza limiti.",

    email: "Email",
    email_or_username: "Email o nickname",
    photo: "Foto",
    password: "tua password",
    verify_age: 'Verifica l\'età',
    verifying_age: 'Verifica età',
    verification_success_title: 'Verifica completata',
    verification_success_desc: 'La tua età è stata verificata con successo.',
    verification_failed_title: 'Verifica fallita',
    verification_failed_desc: 'La verifica non è stata superata. Puoi riprovare selezionando o caricando una foto diversa.',
    verification_limit_title: 'Limite Raggiunto',
    verification_limit_desc: 'Hai superato il numero massimo di tentativi di verifica dell\'età. Riprova più tardi.',
    try_again_in: 'Riprova tra',
    close: 'Chiudi',
    okay: 'Okay',
    start_verification: 'avvia la verifica',
    choose_photo: 'Scegli foto',
    age_verification_photo_instruction: 'Si prega di fornire una foto in cui il viso sia chiaramente visibile. La foto deve contenere una sola persona.',
    age_verification_description: 'Per verificare la tua età, segui le istruzioni.',
    verify_now: 'Verifica ora',
    stay_logged_in: "Rimanere collegato?",
    new_to_barebuddy: "Nuovo su Buddy?",
    join_now: "Registrati Subito!",
    // what_is_barebuddy: "What is BareBuddy? Find out more",
    recover_password: "Recupera la password",
    reset_password: "Resetta la password",
    confirm_password: "Conferma la password",
    recover_now: "Recupera ora",
    create: "Creare",
    start: "Inizio",
    age_modal:{
        'age_check' : 'Verifica dell\'età',
        'contain_sensitive_material':'Questa pagina potrebbe contenere materiale sensibile.',
        'you_need_eighteen':'Devi avere più di 18 anni per continuare.',
    },
    join_modal:{
        become_a_member: "Diventa membro ora e goditi tutte le funzionalità.",
        its_quick_and_free: "È veloce e gratuito!",
        already_a_member:"Già membro?",
    },
    passwords: {
        password: "Le password devono essere di almeno sei caratteri e corrispondere.",
        reset: "La tua password è stata reimpostata!",
        sent: "Se l'e-mail è registrata, riceverai un link di recupero.",
        token: "Questo link per il reset della password non è valido.",
        user: "Se l'e-mail è registrata, riceverai un link di recupero.",
    },
    welcome: {
        what_next: "Cosa vorresti fare ora?",
        nickname: "Soprannome",
        nickname_description: "Completa il tuo profilo ora.",
        discover: "Scopri BUDDY",
        discover_description: "Chatta, incontra, rilassati, guida e molto altro da scoprire.",
        pro: "Aggiornamento a Pro",
        pro_description: "Divertimento infinito con la versione Pro."
    },
    invalid_credentials: "Le credenziali dell'utente non erano corrette.",
    reg: {
        // step1: "Step 1",
        // step2: "Step 2",
        // step3: "Step 3",
        ready: "Pronto",
        automatic_location: "Posizione automatica",
        manual_location: "Localizzazione manuale",
        location_defining: "Definizione della posizione...",
        choose_password: 'Scegli una password',
        password_looks_good: "La tua password sembra buona.",
        pick_nickname: "Scrivi un soprannome per il tuo profilo Buddy.",
        nickname: "Nickname",
        pick_handle: "Ecco il tuo link Buddy:",
        suggestions: 'Suggerimenti',
        password_description: "la tua password deve essere min. 6 caratteri di lunghezza",
        handle_already_taken : "Questo link Buddy è già stato preso.",
        handle_available: "Il link Buddy è disponibile.",
        handle_description : "Il tuo link Buddy aiuta gli altri a trovare il tuo profilo. Puoi cambiarlo ora o più tardi nelle impostazioni.",
        birthdate: "Data di nascita",
        next: "Continua",
        enter_email_address: "La tua email",
        almost_finished: "Quasi finito...",
        add_photo_text: "Aggiungi una foto in modo che\n" +
            "gli buddies possano vederti.",
        i_am_ready: "Sono pronto",
        skip: "Salta",
        back: "INDIETRO",
        add_photo: "Aggiungi foto",
        you_made_it: "Ce l'hai fatta!",
        accept_terms_privacy_text: "Premendo \"Continua\" assicuro di avere almeno 18 anni e di aver letto {0} e accettato le {1}.",
        accept_terms_privacy_text_barebuddy: "By entering, you agree to our {0} and {1}.",
        terms_of_service: "Terms of Service",
        you_must_be_eighteen: "You must be over 18 years old to enter",
        terms_of_use: "Condizioni d'uso.",
        privacy_policy: "l'Informativa sulla privacy",
        finish: "Fine",
        cancel: "Annulla",
        upload: "Carica",
        welcome_to_bb: "Benvenuto in BUDDY",
        where_are_you_located: "Dove abiti?",
        use_current_location: "Usa la mia posizione attuale",
        choose_location_manually: "Scegli posizione manualmente",
        lets_go: "Pronto",
        upload_photo: "Carica foto",
        human_verification_required: "Completa il Captcha per continuare",
        try_another_photo: "prova un'altra foto",
        map: "Mappa",
        use_gps: "Usa GPS",
        gps: "GPS",
        type_address: "Digita il tuo indirizzo",
    },
    links: {
        about_us: "Chi siamo",
        imprint: "Stampa",
        support: "Supporto",
        terms: "Termini di Utilizzo",
        community_guidelines: "Linee guida della community",
        privacy: "Dichiarazione sulla tutela della privacy",
        billing_support: "Supporto alla fatturazione",
    },
    profile_preview: 'Anteprima del profilo',
    public_gallery: 'Galleria pubblica',
    nearby: "Nelle vicinanze",
    recent: "Recenti",
    shuffle: "Shuffle",
    favorites: "Preferiti",
    favorites_online: "Preferiti online",
    online: "Online",
    send_photo: "Invia foto",
    send_location: "Invia posizione",
    set_location: "Imposta posizione",
    type_something: "Digita qualcosa…",
    all: "Tutti",
    unread: "Non letto",
    pos_of_total: "{position} di {total}",
    block_user: "Blocca utente",
    report_user: "Segnala utente",
    user_not_found: 'Utente non trovato',
    cancel: "Annulla",
    online_now: "Online ora",
    away: "Online di recente",
    offline: "Non disponibile",
    about: "Informazioni",
    height: "Altezza",
    weight: "Peso",
    body: "Fisico",
    position: "Posizione",
    penis: "Cazzo",
    hiv: "Stato",
    drugs: "Candy",
    info: "Info",
    stats: "Profile",
    photos: "Foto",
    settings: "Impostazioni",
    share: "Condividere",

    open_mailbox: 'Aprire casetta postale',

    about_me: "Su di me",
    tags: "Tag",
    access: "Accesso",
    profile_account: "Account",
    account: "Account",
    logout: "Esci",
    preferences: "Preferenze",
    show_age: "Mostra età",
    yes: "Sì",
    no: "No",
    join: "Unisciti",
    host: "Host",
    member: "Membro",
    language: "Lingua",
    unit_system: "Unità di misura",
    metric: "Metrico",
    imperial: "Imperiale",
    website_design: "Design del sito web",
    old: "Vecchio",
    reset: "Reset",
    unblock_users: "Sblocca gli utenti",
    delete_my_profile: "Elimina il mio profilo",
    your_profile_picture: "Foto Profilo",
    public_pictures: "Immagini pubbliche",
    can_select_count: "{count}/{total}",
    make_photo_private: "Rendi la foto privata",
    make_photo_public: "Rendi la foto pubblica",
    set_profile_picture: "Imposta come immagine del profilo",
    delete_photo: "Elimina foto",
    display_name: "Nickname",
    display_link : 'Buddy link',
    display_club_link_or_title: 'clublink or title',
    location: "Posizione",
    support: "Supporto",
    photo_message: "Foto-messaggio",
    distance_away: "{distance} da te",
    set_current_location: "Imposta posizione corrente",
    location_message: "Messaggio di posizione",
    no_users_around: "Non ci sono Buddies nelle tue vicinanze",
    no_more_users_around: "Non ci sono altri Buddies nelle tue vicinanze",
    to_see_members_become_a_member: 'Per vedere più utenti, diventa membro.',
    no_chat_messages: "La cronologia è vuota",
    no_more_chat_messages: "Non ci sono altri messaggi nella cronologia chat",
    message_not_delivered: "non consegnato - tocca per inviare di nuovo",
    old_password: "Vecchia password",
    new_password: "Nuova password",
    new_password_confirmation: "Ripeti password",
    password_modified: "La tua password è stata modificata con successo",
    wrong_old_password: "La vecchia password è errata",
    save: "Salva",
    are_you_sure_delete_profile: "Sei sicuro di voler cancellare il tuo profilo?",
    all_users_unblocked: "Tutti gli utenti sono stati sbloccati con successo",
    no_tags: "aggiungi i tuoi tag qui",
    add_tag: "digita un singolo tag e premi Torna",
    link_copied: "Link copiato",

    write_us_help: "Scrivici per Aiuto, Suggerimenti e altro ancora",
    automatic_location: "Riconoscimento automatico",
    manual_location: "Imposta posizione manuale",
    address: "Indirizzo",
    fail_load_location: "Impossibile accedere alla tua posizione. Vuoi indicare la tua posizione manualmente?",
    fail_auto_choose_manual_location: "Impossibile accedere alla tua posizione. Scegli la tua posizione manualmente.",
    this_is_profile_picture: "Questa è la tua immagine del profilo",
    sure_delete_conversation: "Eliminare la cronologia delle conversazioni?",
    failed_load_user: "Impossibile caricare il profilo utente",
    please_register: "Registrati per favore",
    recover_it: "Recuperala", //we talk here about forgotten 'password' on login form
    not_a_member: "Non sei ancora membro?",
    fail_block_user: "Impossibile bloccare l'utente",
    user_reported_confirmation: "Grazie per aver segnalato l'utente. Esamineremo la segnalazione il prima possibile.",
    register_here: "Registrati qui",
    options: {
        body: {
            slim: "Snello",
            average: "Nella media",
            athletic: "Atletico",
            muscular: "Muscoloso",
            stocky: "Robusto"
        },
        position: {
            top: "Attivo",
            more_top: "Più attivo",
            bottom: "Passivo",
            more_bottom: "Più passivo",
            versatile: "Versatile"
        },
        hiv: {
            positive: "Positivo",
            negative: "Negativo",
            undetectable: "Non rilevabile",
            prep: "PrEP",
            unknown: "Sconosciuto"
        },
        drugs: {
            yes: "Sì",
            no: "No",
            socially: "A volte",
        }
    },
    Sunday: "Domenica",
    Monday: "Lunedì",
    Tuesday: "Martedi",
    Wednesday: "Mercoledì",
    Thursday: "Giovedì",
    Friday: "Venerdì",
    Saturday: "Sabato",
    January: "Gennaio",
    February: "Febbraio",
    March: "Marzo",
    April: "Aprile",
    May: "Maggio",
    June: "Giugno",
    July: "Luglio",
    August: "Agosto",
    September: "Settembre",
    October: "Ottobre",
    November: "Novembre",
    December: "Dicembre",
    back: "Indietro",
    report_harassment: "Molestie",
    report_fake: "Fake",
    report_spam: "Spam",
    report_under_age: "Minorenne",
    report_other: "Altro",
    cookies_message: "I cookie ci aiutano a fornire i nostri servizi. Utilizzando i nostri servizi, l'utente accetta di utilizzare i cookies.",
    learn_more: "Scopri di più",
    profile_is_deleted: "Questo profilo è stato eliminato",
    crop_photo: "Modifica foto",
    install_pwa_ios_message: "Installa BUDDY sul tuo telefono: tap <img src='/assets/img/iphone-share-btn.jpg' style='height: 26px' /> and then <strong>Add to Home Screen</strong>: <img style='height: 30px' src=''/assets/img/add-home-screen-en.png' />",
    you_are_offline: "Sembra che tu sia offline",
    show_map: "Mappa",
    subscribe_to_newsletter: "Newsletter",
    emails_reminders: "Riepilogo email",
    daily: "Giornaliero",
    weekly: "Settimanale",
    monthly: "Mensile",
    never: "Mai",
    "validation.imageable": "Tipo di immagine non supportato. Carica solo immagini JPG, PNG o GIF.",
    user_blocked_confirmation: "L'utente è stato bloccato",
    search_users: "Nickname",
    sure_delete_event: "Eliminare questo evento?",

    home: {
        come_inside: 'Entra',
        content_removal : "Rimozione di contenuto",
        bad_boys_society: "Bad Boys Society",
        create_account: "Crea un account",
        tagline: "BUDDY",
        fun: "Costruire una migliore app gay",
        login: "E-mail o nickname",
        password: "Password",
        log_in: "Accedi",
        remember_me: "Ricordami",
        forgot_password: "Password dimenticata?",
        new_here: "Sei nuovo qui?",
        sign_up: "Registrati",

        wants: "Mostra il tuo lato birichino.",
        wants_desc: "Hai esperienza o sei solo curioso? Entra a far parte della comunità di BUDDY ed esplora i tuoi kinks! Tocca e inizia a chattare istantaneamente. Cerca gli hashtag per trovare rapidamente i kinksters che più si abbinano a te.<br><br>Appuntamenti focosi rapidissimi.",

        videos: "Guarda e condividi video.",
        videos_desc: "Guarda i tantissimi stuzzicanti video dei nostri membri. Condividi i tuoi video preregistrati in privato chatta o mostrali nel tuo profilo pubblico.<br><br>Non è mai stato così divertente.",

        calendar: "Trova amici con cui divertirti.",
        calendar_desc: "Crea annunci privati nel nostro calendario. Mostra agli altri buddies quello che ti piace e quello che desideri. Non ti basta? Organizza gruppi e trova nuovi amici.<br><br>Incontra dei kinksters, proprio come te.",

        everywhere: "Allora...qual è il tuo kink?",
        everywhere_desc: "Utilizza il nostro sito web senza censure oppure scarica l'app BUDDY.<br><br>Iscriviti ora e provala!",

        generation: "Benvenuto nel Buddyverso",
        generation_desc: "Crediamo di poter rendere un servizio alla nostra community rendendo BUDDY accessibile a tutti. A differenza di altre app, offriamo le funzioni più utili in modo totalmente gratuito. Nessun limite, nessuna pubblicità fastidiosa. Vogliamo diventare la migliore e più grande app gay per chi ama uno stile di vita kinky e birichino. Iscrivetevi ora e spargete la voce.<br><br>Più buddies significa più divertimento!",

        sign_up_now: "Registrati Subito",

        company: "Azienda",
        about_us: "Chi siamo",
        blog: "Blog",
        help: "Aiuto",
        support: "Supporto alla fatturazione",

        legal: "Area legale",
        privacy: "Dichiarazione sulla tutela della privacy",
        terms: "Termini di Utilizzo",
        community_guidelines: "Linee guida della community",
        usc: "18 USC 2257",
        imprint: "Impressum",

        languages: "Lingue",
        follow_us: "Seguici"
    },

    home_old: {
        tagline: "Buddies<br/>&<br/>Benefits",
        easy_raw_free: "MEET MEN ON PREP",
        // responsible_dating: "Responsible bareback dating",
        home_text: `Come inside and meet gay guys near you.
            BUDDY is the first network
            for men on PrEP or TasP.`,
        join_start: "Join now and start dating immediately.",
        get_started: "Get started",
        screen_title1: "Easy.",
        screen_sub1: "On the hunt!",
        screen_text1: "Browse profiles, chat and send your videos with ease.",
        screen_title2: "FUN.",
        screen_sub2: "Pure and natural!",
        screen_text2: "No discussions, no judgement. Save your time. Just chat and meet.",
        screen_title3: "Free.",
        screen_sub3: "Join for free.",
        screen_text3: "Unlimited profile views, messages and pictures. BUDDY lets you have unlimited fun.",
    },

    company: "Azienda",
    legal: "Area legale",
    community_guidelines: "Linee guida della community",
    social_media: "Social Media",
    edit_your_photo: "Sei bellissima!",
    complete_profile: "Completa il mio profilo",
    add_more_photos: "Aggiungi altre foto",
    check_out_guys: "Dai un'occhiata ai Buddies",
    members_login: "I membri accedono da qui",
    change_password: "cambia password",
    create_your_event_plus: "Crea il tuo evento. Clicca +",
    create_new_event: "Crea un nuovo evento:",
    create_event: "Crea evento",
    create_your_club_plus: "Crea il tuo club. Clicca +",
    create_new_club: "Crea un nuovo club:",
    create_club: "Crea club",
    title: "Titolo",
    date: "Date",
    time: "Ora",
    add_event_details: "Aggiungi alcuni dettagli:",
    event_description: "Descrizione evento",
    club_description: 'Descrizione',
    club_description_placeholder: 'Di cosa tratta il tuo club?',
    joined_to_club: "ssi è unito",
    left_to_club: "se n'è andato",
    private: "Private",
    public: "Public",
    non_commercial: "non-commercial",
    commercial: "commercial",
    add_tags_optional: "Aggiungi tag (facoltativo) :",
    select_address: "Seleziona indirizzo",
    location_details: "Dettagli posizione (facoltativo)",
    location_example: "(eg: my flat, venue name)",
    full_address: "Full address",
    city_only: "Only city",
    event_choose_photos: "Scegli le immagini per il tuo evento",
    club_choose_photos: 'Scegli le immagini per il tuo club',
    display: "Visualizza:",
    alternative: '',
    hot: "foto sexy (opzionale)",
    preview: 'immagine sicura',
    for_censored_app: "per app censurata",
    visible_only_uncensored_website: "visibile solo su sito web non censurato",
    preview_picture: "Anteprima",
    submit_event: "Invia",
    event_address: "Indirizzo dell’evento",
    club_address: 'Città',
    please_select_preview_picture: "Seleziona immagine di anteprima",
    set_preview_picture: "Imposta come immagine di anteprima",
    event_successfully_added: "Il tuo evento è stato aggiunto con successo",
    event_successfully_updated:"Il tuo evento è stato aggiornato con successo.",
    no_events_around: "Nessun evento nelle vicinanze",
    no_more_event_around: "Nessun altro evento nelle vicinanze",
    club_successfully_added: 'Il tuo club è stato aggiunto con successo',
    no_clubs_around: 'Nessun club nelle vicinanze',
    no_more_club_around: 'Nessun altro club nelle vicinanze',
    edit: "Modifica",
    recipient_will_not_see_you: "Il destinatario non vedrà il tuo profilo reale.",
    public_videos: "Video pubblici",
    send: "Invia",
    event_choose_videos: "Scegli i video per il tuo evento",
    delete_video: "Elimina video",
    add_video: "Aggiungi un video",
    videos: "Video",
    play_video: "Riproduci video",
    video_uploaded_processing: "Il tuo video è stato caricato correttamente ed è ora in fase di elaborazione. Ti avviseremo non appena sarà pronto.",
    video_processed: "Il tuo video è pronto per l'uso",
    video_message: "Video Messaggio",
    sure_delete_photo: "Eliminare questa foto?",
    sure_delete_video: "Eliminare questo video?",
    too_hot: "Troppo Focoso",
    notifications: "Notifiche",
    push_notifications: "Notifiche push",
    help: "Aiuto",
    profile: "Profilo",
    user_blocked: "Hai bloccato questo utente o lui ha bloccato te.",
    open_blocked_users: "Apri l'elenco degli utenti bloccati",
    faq: "FAQ",
    support_chat: "Chat Supporto",
    click_here_tutorials: "Fai clic qui per i tutorial",
    send_direct_message: "Inviaci un messaggio diretto",
    app: "App",
    security: "Sicurezza",
    notification_sound: "Suono di notifica",
    deactivate_my_profile: "Disattiva il mio profilo",
    deactivate_or_delete_my_profile: "Disattiva o elimina il mio profilo",
    customize_sharing_links: "Personalizza i link di condivisione",
    delete_all_sharing_links: "Elimina tutti i collegamenti di condivisione",
    delete_all: "Cancella tutto",
    deactivate_account: "Disattiva account",
    taking_break_buddy: "Ti prendi una pausa da BUDDY?",
    deactivate_text_description: "Disattiva il tuo profilo e sparisci completamente dal radar e dalle ricerche.",
    deactivate: "Disattiva",

    /* It is not clear what this translation is for */
    // Se vuoi lasciare BUDDY per sempre, {0} per eliminare il tuo profilo. Questo è permanente e non potrà essere annullato. Dovrai creare un nuovo profilo quando vorrai tornare. Ricorda, ogni amico ha bisogno di un BUDDY :-)",

    click_here: "clicca qui",
    are_you_sure_deactivate_profile: "Sei sicuro di voler disattivare il tuo profilo?",
    inactive_profile: "Profilo inattivo",
    account_is_deactivated: 'Il tuo adorabile profilo BUDDY è attualmente disattivato.<br /> Fai clic su "Attiva" per riattivarlo.',
    activate: "Attiva",
    leave: "Lasciare",
    profile_is_deactivated: "Questo profilo è attualmente disattivato",
    prep_safer_use: "PrEP, TasP, STD, Safer use",
    information_education: "Information & Education",
    prep_chat: "PrEP Chat",
    channel_prep_questions: "Channel for 1:1 PrEP questions",
    censored_event_title: "***Content Warning***",
    censored_event_description: "***This event may contain sensitive material*** <br /><br />Your media settings are configured to warn you about sensitive material. <br />To view it, you need to change your selection in your safety settings",
    censored_content_warning: "Le tue impostazioni multimediali sono configurate per avvisarti riguardo alla presenza di materiale sensibile. <br /><br />Per visualizzarlo, è necessario modificare la selezione nelle impostazioni di sicurezza",
    change_settings: "Modifica le impostazioni",
    show_more: "Mostra di più",
    display_sensitive_events: "APP: eventi sensibili",
    display_sensitive_media: "APP: materiale senisibile",
    display_sensitive_media_web: "Web: materiale senisibile",
    tiles: "Pannelli",
    list: "Elenco",
    filter: "Filtro",
    pics: "Foto",
    age: "Età",
    new: "Nuovo",
    ok: "OK",
    taps: "Tocchi",
    visitors: "Visitatori",
    visited: "Visitato",
    no_visitors: "'Ancora nessun visitatore',",
    no_more_visitors: "Nessun altro visitatore",
    no_visited: "Ancora nessuna visita",
    no_more_visited: "Niente più visite",
    no_taps: "No taps",
    no_more_taps: "Nessun tocco",

    discreet_mode: "Invisibile",
    discreet_mode_on: "Mask Mode (ON)",
    discreet_mode_off: "Mask Mode (OFF)",

    hide_profile_completely: "Nascondi completamente il profilo",
    upgrade_to_pro: "Aggiornamento a PRO",
    upgrade_to: "Aggiorna a",
    upgrade_now: "Aggiorna adesso",
    upgrade: "Aggiorna",
    click_here_to_upgrade: "Clicca qui per aggiornare",
    click_here_to_cancel: "Clicca qui per annullare",
    pro: "'PRO',",
    cancel_pro: "Annulla PRO",
    thank_you_for_being_a_pro: "Grazie per essere un PRO Buddy",
    successful_pro_upgrade: "Ora sei un PRO Buddy!",
    failed_pro_upgrade: "Ops... Qualcosa è andato storto",
    we_hope_you_enjoyed_pro: "Ci auguriamo che Buddy PRO ti sia piaciuto",

    delete_this_message: "Eliminare questo messaggio?",
    delete: "Elimina",
    removed: "rimosso",

    pro_slides_1_title: "Invisibile",
    pro_slides_1_description: "con Modalità Maschera",
    pro_slides_2_title: "Annulla messaggi",
    pro_slides_2_description: "e controlla se ha letto <br> il tuo messaggio",
    pro_slides_3_title: "Altri filtri",
    pro_slides_4_title: "Senza limiti",
    pro_slides_4_description: "preferiti, blocchi, visitatori,<br> foto pubbliche e video",
    pro_slides_5_title: "Più divertimento",
    pro_slides_5_description: "guarda tutti i video e le foto",

    notifications_button: 'Attiva notifiche',
    splash_notifications_title: 'Resta aggiornato',
    splash_notifications_description: 'Per favore attiva le notifiche per ricevere messaggi e avvisi dai tuoi buddy',

    splash_blocks_title: "Blocchi illimitati",
    splash_blocks_description: "per blocchi illimitati passa a",
    splash_favorites_title: "Preferiti illimitati",
    splash_favorites_description: "per preferiti illimitati, passa a",
    splash_mask_title: "Invisibile",
    splash_mask_description: "con Invisibile passa a",
    splash_censored_title: "Vedi altro",
    splash_censored_description: "per contenuti senza limiti passa a",
    splash_visitors_title: "chi mi ha visto",
    splash_visitors_description: "per vedere tutti i tuoi visitatori passa a",
    splash_filters_title: "Altri filtri",
    splash_filters_description: "Per avere più filtri, esegui l'upgrade a",
    splash_media_title: "Foto e video pubblici illimitati",
    splash_media_description: "per foto / video senza limitazioni, passa a",
    splash_deletemsg_title: "Cancella un messaggio",
    splash_deletemsg_description: "per eliminare un messaggio passa a",
    splash_change_settings_title: "Le tue impostazioni multimediali sono configurate in modo da avvisarti in caso di materiali sensibili.",
    splash_change_settings_description: "Per visualizzarli, sarà necessario modificare le impostazioni di sicurezza.",
    splash_events_title: "Altri eventi",
    splash_events_description: "Per altri eventi, esegui l'upgrade a",

    pro_upgrade_message_desktop: "Gli abbonamenti si rinnoveranno automaticamente a meno che non vengano annullati entro 24 ore prima della fine del periodocorrente.<br> Visita <a href=\"http://cs.segpay.com\">SEGPAYEU.COM</a>, il nostro agente di vendita autorizzato<br>. Gli addebiti appariranno sull'estratto conto della tua carta di credito come <a href=\"http://cs.segpay.com\">SEGPAYEU.COM *BUDDY</a>.",
    pro_upgrade_message_mobile: "Gli abbonamenti si rinnoveranno automaticamente a meno che non vengano annullati entro 24 ore prima della fine del periodo corrente.",
    payment_blocked: "Richiesta di pagamento in corso.",
    you_cant_send_messages_to_this_user: "Non puoi inviare messaggi a questo utente.",

    events: {
        report: {
            title: "Segnala Evento",
            wrong_type: "Categoria sbagliata",
            illegal: "Illegale",
        },
        type: {
            friends: 'Friends',
            fun: 'Date',
            bang: 'Chill',
            guide: 'Guide',
            chemsfriendly: "chemsfriendly",
            required: "Seleziona una categoria",
        },
        date: {
            today: "oggi",
            tomorrow: "domani",
            pick_date: "date"
        },
        link_my_profile: "Collega il mio profilo",
        not_found: "Evento non trovato",
        report_success: "Grazie per aver segnalato l'evento. Esamineremo la segnalazione il prima possibile.",
        new_event: "Nuovo Evento",
        new_bang: "Nuovo bang",
        my_events: "I miei eventi",
        publish: "Pubblicare",
        select_type: 'Che tipo di evento vorresti creare?',
        about_guide: "eventi pubblici per tutti (feste, festival, comunità)",
        about_fun: "trova un buddy per attività private (1:1)",
        about_bang: "organizza eventi privati di gruppo",
        invitation_only_event: "Solo invito (evento privato)",
        please_add_favourite_buddies_first: "Aggiungi prima gli buddies preferiti",
        accept: "Accettare",
        decline: "Declinare",
        invited: "Invitato",
        invite: "Invita",
    },

    clubs: {
        admin: 'Admin',
        invites: 'Invites',
        member: 'Member',
        nearby: 'Nearby',
        more_clubs: 'Più club',
        hide_club_admin: "Nascondi l'amministratore del club",
        report: {
            title: 'Segnala Club',
            wrong_type: "Categoria sbagliata",
            illegal: "Illegale",
        },
        type: {
            discover: 'Scoprire',
            my_clubs: 'I miei club',
            chemsfriendly: 'chemsfriendly',
            required: "Seleziona una categoria",
        },
        date: {
            today: "oggi",
            tomorrow: "domani",
            pick_date: "date"
        },
        not_found: "Club non trovato",
        report_success: "Grazie per aver segnalato un club. Esamineremo la segnalazione il prima possibile.",
        new_club: 'Nuovo club',
        my_clubs: 'I miei club',
        publish: 'Publish',
        invitation_only_club: "Solo invito (club privato)",
        write_to_support_to_open_club: "Scrivi al supporto se vuoi modificare la privacy di questo club",
        please_add_favourite_buddies_first: "Aggiungi prima gli buddies preferiti",
        accept: "Accettare",
        decline: "Declinare",
        invited: "Invitato",
        invite: "Invita",
    },

    payment: {
        coming_soon: "In arrivo",
        month: "al mese",
        one_month: "mese",
        three_months: "mesi",
        twelve_months: "mesi",
        your_promotion_code: "Il tuo codice promozionale",
        please_select_payment_option: "Seleziona un'opzione di pagamento.",
        use_promo_code: "Usa un codice PROmo",
        credit_card: "Carta di credito",
        alternative_payments: "Pagamenti alternativi",
        renews_automatically_until_cancelled: "Rinnovo automatico fino a cancellazione.",
        active_until: "Il tuo stato PRO è attivo fino a",
        one_time: "Una tantum",
        no_need_to_cancel: "(Nessuna necessità di cancellare!)",
        upgrade: {
            one_month: "Upgrade per 1 mese",
            three_months: "Upgrade per 3 mesi",
            twelve_months: "Upgrade per 12 mesi",
        },
        upgrade_paypal: {
            one_month: "PayPal per 1 mese",
            three_months: "PayPal per 3 mesi",
            twelve_months: "PayPal per 12 mesi",
        },
        send:"Invia",
        thank_you: "Grazie!",
        return_to_buddy: "Ritorna a BUDDY",
        paypal: {
            message: "<p>Per favore, inserisci il tuo indirizzo e-mail PayPal.</p><br /><p>Ti invieremo un link PayPal a quell'indirizzo.</p><br /><p>Dopo aver ricevuto il pagamento, aggiorneremo il tuo profilo Buddy.</p>",
            successMessage: "<p>Abbiamo ricevuto la tua richiesta di upgrade.</p><br><p>Ti invieremo presto un link PayPal.</p><br /><p>Dopo aver ricevuto il pagamento, <br /> per favore, concedici un po' di tempo <br/>per effettuare il tuo upgrade.</p> <br/><p>Lo facciamo a mano! ✊🏻💦</p>"
        },
        features: {
            unlock_filters : "Sblocca tutti i filtri",
            be_invsble: "Essere invisibile",
            see_all_who_viewed_me: "Vedere tutti coloro che mi hanno visualizzato",
            remove_messages: "Rimuovere i messaggi",
            make_notes_on_profile: "Fare note sui profili",
            unlimited_favorites: "Preferiti illimitati",
            view_hot_medias: "Visualizzare i media XXX nell'app",
            see_if_your_message_has_been_read: "Vedere se il tuo messaggio è stato letto",
            see_wh_marked_you_favorite: "Vedere chi ti ha contrassegnato come preferito",
            hide_profile_visits: "Nascondere le visite al profilo"
        }

    },

    uploadVideos: {
        error: {
            lowDuration: "La durata del video deve essere superiore a 1 secondo.",
            highDuration: "La durata del video deve essere inferiore a 15 min.",
        },
    },

    rush: {
        running_for_x_days: "Attivo per {days} giorni",
        stars_and_strips_upgrade: "Stelle e strisce. Aggiorna a",
        announce: "<span>Ciao Buddies,</span><span> i developer di Buddy hanno pensato a qualcosa di nuovo per voi.</span><span>{0} - piccole app all'interno di BUDDY, utili e coinvolgenti</span><span>. Divertiti curiosando!</span>",
        how_to: {
            title: "RUSH - Come...",
            create: "Crea la tua striscia",
            name: "Dai un nome alla tua striscia",
            media: "Seleziona un'immagine o scrivi un testo",
            publish: "Pubblica la tua striscia e aggiungi altri contenuti",
        },
        welcome: {
            title: "Benvenuto in RUSH",
            story: {
                title: "La tua storia.",
                description: "Aggiungi foto alla tua striscia e mostrale a tutti i tuoi buddies.",
            },
            post: {
                title: "Posta ogni giorno.",
                description: 'Allunga la "corsa" Rush e ricevi più applausi.',
            },
            applause: {
                title: "Altri applausi?!",
                description: "Otterrai un pannello di anteprima più grande. Ciò significa più visualizzazioni buddy!",
            },
            attention: {
                title: "Attention!",
                description: "Se non ci saranno nuove foto entro 24 ore, la tua striscia scomparirà. La corsa 'Rush' è finita.",
            },
        },
    },
    sure_unblock_user: "Sblocca questo profilo?",

    party_on_buddies1: "PARTY ON,",
    party_on_buddies2: "BUDDIES!",
    party_on_text1: "There is something new in the Buddyverse. Check out the new \"Guide\" section in our calendar and find parties and events nearby.",
    party_on_text2: "After two years it's about time we go out again and have fun! Let's support event organisers together and rock the party.",

    are_you_sure_you_want_to_delete_all_sharing_links: "Sei sicuro di voler eliminare tutti i link di condivisione?",
    all_links_will_be_deactivated: "Tutti i collegamenti verranno disattivati.",
    all_sharing_links_deleted_successfully: "Tutti i collegamenti di condivisione sono stati eliminati correttamente",
    this_is_your_sharing_code: "Questo è il tuo link di condivisione (clicca per copiare)",
    share_your_selected_videos: "Condividi i tuoi video selezionati con<br>i ragazzi che non sono ancora su Buddy.",
    send_via_whatsapp: "Condividi via Whatsapp",
    tap_on_the_videos_you_want_to_share: "Tocca i video che vuoi condividere",
    cancel_share: "Annulla",
    share_now: "Condividi",
    status:"Stato",
    you_need_to_be_a_pro_for_editing:"Devi essere un <strong>PRO</strong> per la modifica",
    expire_at_date:"Scadenza alla data",
    expire_at_time:"Scade a tempo",
    views_limit:"Limite di visualizzazioni",
    you_dont_have_any_links:"Non hai nessun link",
    link_settings_saved:"Impostazioni del collegamento salvate",
    can_not_get_sharing_links:"Impossibile ottenere collegamenti di condivisione",
    copied_to_clipboard: "copiato negli appunti",
    share_whatsapp_test: "Ecco il link al mio video su buddy.net: ",
    share_videos: 'Condividi video',
    accept_all: 'Accetta tutto',
    no_messages : 'Nessun messaggio',
    you : 'Te',
    has: 'si è',
    have: 'ne sei',
    joined: 'unito',
    left: 'andato',
    web_push_notifications: 'Notifiche web push',
    modal_pro_upgrade_description : 'Potrai usufruire di questa e di molte altre funzioni se effettuerai al livello PRO.',
    modal_pro_visit_upgrade_description : 'Nascondi la tua visita a questo profilo con PRO',
    note : 'Nota',
    note_textarea_placeholder : "Aggiungi informazioni personali su questo profilo...",
    who_marked_me_favorite : "Chi mi ha segnato come preferito",
    cancel_failed: "Annullamento non riuscito, riprova",
    subscription_canceled: "Abbonamento annullato",
    confirm_cancel: "Vuoi davvero annullare l'abbonamento?",
    cancel_subscription: "Annulla sottoscrizione"
}
